import { client } from '../client';
import { ProviderProfile, UserProfile } from './types/UserProfile';

export const createProviderProfile = async (payload: ProviderProfile, user_id: number): Promise<UserProfile> => {
  const { data } = await client.post<UserProfile>(`/users/${user_id}/provider_profile`, payload);

  return data;
};
